import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgRfid = function SvgRfid(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M12 0C5.39 0 0 5.39 0 12s5.39 12 12 12 12-5.39 12-12S18.61 0 12 0zM6.422 19.172a1.033 1.033 0 01-.703.281c-.235 0-.516-.094-.703-.281-3.938-3.938-3.938-10.36 0-14.297a1.02 1.02 0 011.406 0 1.02 1.02 0 010 1.406c-3.14 3.14-3.14 8.297 0 11.485.375.375.375.984 0 1.406zm2.766-4.36a1.02 1.02 0 010 1.407 1.034 1.034 0 01-.704.281c-.234 0-.515-.094-.703-.281a5.941 5.941 0 010-8.438 1.02 1.02 0 011.407 0 1.02 1.02 0 010 1.407 3.99 3.99 0 000 5.624zM12 14.017c-1.078 0-2.016-.891-2.016-2.016 0-1.078.891-2.016 2.016-2.016A2 2 0 0114.016 12 2 2 0 0112 14.016zm3.516 2.484c-.235 0-.516-.094-.704-.281a1.02 1.02 0 010-1.407 3.99 3.99 0 000-5.624 1.02 1.02 0 010-1.407 1.02 1.02 0 011.407 0 5.942 5.942 0 010 8.438.955.955 0 01-.703.281zm3.515 2.672a1.033 1.033 0 01-.703.281c-.234 0-.515-.094-.703-.281a1.02 1.02 0 010-1.406c3.14-3.141 3.14-8.297 0-11.485a1.02 1.02 0 010-1.406 1.02 1.02 0 011.406 0c3.938 3.938 3.938 10.36 0 14.297z"
  }));
};

export default SvgRfid;